import { EventName } from './constants';

export { EventName };

export const trackAudience = (eventName: EventName) => {
  if (typeof global.Txt !== 'undefined') {
    global.Txt.track({
      eventName,
    });
  }
};
